import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import HeaderStyles from '@stories/Widgets/Header/Header.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.section `
  position: absolute;
  top: calc(100% - var(--headerCtaHeight));
  left: 0;
  display: block;
  background: ${brand.white};
  padding: ${fluid(10, 40)} 0;
  width: 100%;
  box-shadow: 0px 0px 5px 1px ${rgba(brand.black, 0.25)};

  &[data-active='false'] {
    display: none;
  }

  ${HeaderStyles.Container}[data-reduce="true"] & {
    display: none;
  }
`;
const Inner = styled.div `
  ${siteWide};
  ${baseGrid};

  --siteWidth: 1550px;

  gap: calc(var(--gutterWidth) * 0.3) calc(var(--gutterWidth) * 0.75);

  @media ${from(Device.TabletLarge)} {
    width: 100%;
    max-width: var(--maxWidth);
  }
`;
const Item = styled.li `
  display: block;
  grid-column: span 3;
`;
const Link = styled.a `
  ${transition('background-color, color')};

  display: block;
  background: ${brand.beige};
  color: ${brand.black};
  padding: 8px 16px;
  text-decoration: none;

  &:hover,
  &:focus {
    background: ${brand.green};
    color: ${brand.white};
  }
`;
const LinkTitle = styled.span `
  display: block;
  ${fonts.brandonGrotesque.medium}
  font-size: ${fluid(16, 20, Device.TabletLarge)};
  line-height: ${fluid(22, 26, Device.TabletLarge)};
`;
const Divider = styled.li `
  grid-column: span 12;
  height: 1px;
  background-color: ${brand.beige};
  margin: calc(var(--gutterWidth) * 0.25) 0;
`;
const NavigationMegaMenuStyles = {
    Container,
    Inner,
    Item,
    Link,
    LinkTitle,
    Divider,
};
export default NavigationMegaMenuStyles;
